// extracted by mini-css-extract-plugin
export default {"container":"Service_container__YS6Fs","moreBtn":"Service_moreBtn__K3Hg8","card":"Service_card__-DYcd","notes":"Service_notes__qr6xl","card_Inner":"Service_card_Inner__BJKsU"};